import React, { useCallback, useEffect, useState } from 'react'
import { Button } from '../../../elementals'
import { TextAreaField } from '../../../formFields'
import { InputMaybe } from '@adc/sdk/types'

interface AdditionalNotesFieldProps {
  elmId?: string
  value?: InputMaybe<string>
  error?: string
  readOnly?: boolean
  touched?: boolean
  onChange?: (
    event: React.ChangeEvent<HTMLTextAreaElement>,
    data: unknown
  ) => void
  onBlur?: (event: React.FocusEvent<HTMLTextAreaElement>, data: unknown) => void
  onFocus?: (
    event: React.FocusEvent<HTMLTextAreaElement>,
    data: unknown
  ) => void
}

const BUTTON_LABEL = 'Edit Additional Notes'

const additionalNotesField = ({
  elmId,
  error,
  readOnly,
  touched,
  value,
  onChange,
  onBlur,
  onFocus,
}: AdditionalNotesFieldProps) => {
  const [isEditable, setIsEditable] = useState(false)

  useEffect(() => {
    if (readOnly) {
      setIsEditable(false)
    }
  }, [readOnly])

  const handleEditable = useCallback(() => {
    setIsEditable(true)
  }, [])

  return isEditable ? (
    <TextAreaField
      style={{ resize: 'vertical' }}
      className='u-mb-2'
      elmId={elmId}
      error={error}
      value={value}
      placeholder='Enter additional notes'
      maxLength='512'
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      rows={5}
      touched={touched}
      disabled={readOnly}
    />
  ) : (
    <Button
      role='secondary'
      onClick={handleEditable}
      disabled={readOnly}
      title={BUTTON_LABEL}
    >
      {BUTTON_LABEL}
    </Button>
  )
}

export default additionalNotesField
